import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import ModulePreloader from "src/scripts/modules/modulePreloader";
import ModuleNavigation from "src/scripts/modules/moduleNavigation";
import CustomAnimations from "src/scripts/modules/CustomAnimations";
import ModuleModal from "src/scripts/modules/moduleModal";
import Home from "src/scripts/pages/home";
import Work from "src/scripts/pages/work";
import { isMobile } from 'detect-touch-device';
import LazyLoad from "vanilla-lazyload";
const modulePreloader = new ModulePreloader();
const moduleNavigation = new ModuleNavigation();
const moduleModal = new ModuleModal();
const home = new Home();
const work = new Work();


jQuery(document).ready(function () {
  let pageName = jQuery('body').data('page');

  // lazy load
  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
  });
  lazyLoadInstance.update();

  if(isMobile) {
   $('body').removeClass('body_overflow_hidden');
  }

  moduleNavigation.init();

  const animations = new CustomAnimations();
  animations.init();
  animations.initMagneticButtons();
  animations.initGlobalAnimations();
  animations.initNaviAnimations();

  if(pageName == "home") {
    animations.initProfilAnimations();
    animations.initServiceAnimation();
    animations.initKontaktAnimation();
  }
  if(pageName == "work") {
    animations.initWorkDetailAnimation();
    animations.initNextProjectAnimation();
  }

  moduleModal.init();

  // preloader logo
  setTimeout(function () {
    $('.page').addClass("show");
    modulePreloader.hidePreloaderLogo();

    if(pageName == "home") {
      animations.initWorkAnimation();
    }
  }, 500);

  setTimeout(function() {
    modulePreloader.hidePreloader();
    animations.animateNavi();

    if(pageName == "home") {
      home.init();
      animations.initHomeAnimations();
    }
    if(pageName == "work") {
      work.init();
      animations.initWorkdetailsIntroAnimation();
    }
  }, 1000);
});
